import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExpiredDeals = ({ expiredDeals, onSetAlert }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const displayedDeals = isExpanded ? expiredDeals : expiredDeals?.slice(0, 3);

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Icon name="Clock" size={20} className="text-muted-foreground" />
          <h2 className="text-lg font-semibold text-text-primary">Recently Expired Deals</h2>
          <span className="bg-muted text-muted-foreground px-2 py-1 rounded-full text-xs">
            {expiredDeals?.length}
          </span>
        </div>
        {expiredDeals?.length > 3 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={toggleExpanded}
            iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
          >
            {isExpanded ? 'Show Less' : 'Show All'}
          </Button>
        )}
      </div>
      {/* Deals List */}
      <div className="space-y-4">
        {displayedDeals?.map((deal) => (
          <div key={deal?.id} className="flex items-center space-x-4 p-4 bg-muted/50 rounded-lg opacity-75">
            {/* Product Image */}
            <div className="flex-shrink-0">
              <Image
                src={deal?.image}
                alt={deal?.imageAlt}
                className="w-16 h-16 object-cover rounded-lg"
              />
            </div>

            {/* Product Info */}
            <div className="flex-1 min-w-0">
              <h3 className="font-medium text-text-primary truncate mb-1">
                {deal?.title}
              </h3>
              <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                <span>Was ${deal?.salePrice}</span>
                <span className="line-through">${deal?.originalPrice}</span>
                <span className="text-destructive font-medium">
                  -{Math.round(((deal?.originalPrice - deal?.salePrice) / deal?.originalPrice) * 100)}%
                </span>
              </div>
              <div className="flex items-center space-x-2 mt-1">
                <Icon name="Calendar" size={14} className="text-muted-foreground" />
                <span className="text-xs text-muted-foreground">
                  Expired {new Date(deal.expiredDate)?.toLocaleDateString()}
                </span>
              </div>
            </div>

            {/* Actions */}
            <div className="flex-shrink-0 space-y-2">
              <Button
                variant="outline"
                size="sm"
                iconName="Bell"
                iconPosition="left"
                onClick={() => onSetAlert(deal)}
                className="w-full"
              >
                Set Alert
              </Button>
              <Button
                variant="ghost"
                size="sm"
                iconName="ExternalLink"
                iconPosition="right"
                className="w-full text-muted-foreground"
              >
                View Product
              </Button>
            </div>
          </div>
        ))}
      </div>
      {/* Empty State */}
      {expiredDeals?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="Clock" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h3 className="font-medium text-text-primary mb-2">No Expired Deals</h3>
          <p className="text-muted-foreground text-sm">
            Check back later to see recently expired deals and set alerts for similar products.
          </p>
        </div>
      )}
      {/* Info Banner */}
      {expiredDeals?.length > 0 && (
        <div className="mt-6 p-4 bg-accent/10 border border-accent/20 rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={16} className="text-accent mt-0.5" />
            <div className="text-sm">
              <p className="text-text-primary font-medium mb-1">
                Missed a deal? Set up alerts!
              </p>
              <p className="text-muted-foreground">
                We'll notify you when similar deals become available or when these products go on sale again.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpiredDeals;